
function LocationMap(props:any) { return (

    <div className="orm-html" data-symbol={props.symbol}>
     {props.symbol}
    </div>
)}

export default LocationMap;